import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { Button, Popover, Text } from '@bigcommerce/big-design';
import { ContentCopyIcon, OpenInNewIcon, VisibilityIcon } from '@bigcommerce/big-design-icons';

export function NewTabButton({ orderId }) {
	const handleOpenInNewTab = () => {
		const bcAdminBase = "https://store-le3vzvrwix.mybigcommerce.com/manage/app/32510";
		const targetUrl = `${bcAdminBase}?view_order=${orderId}`;
		window.open(targetUrl, '_blank');
	};

	return (
		<div className="action-button">
			<Button onClick={handleOpenInNewTab}>
				<OpenInNewIcon size="medium" title="Open in new tab" />
			</Button>
		</div>
	);
}

export function ViewOrderButton({ orderId }) {
	const navigate = useNavigate();

	return (
		<div className="action-button">
			<Button onClick={() => navigate(`/orders/${orderId}`)}>
				<VisibilityIcon size="medium" title="View Order" />
			</Button>
		</div>
	);
}

export function CopyOrderNumberButton({ orderId }) {
	const [isOpen, setIsOpen] = useState(false);
	const [buttonRef, setButtonRef] = useState(null);

	useEffect(() => {
		let timeoutId;
		if (isOpen) {
			timeoutId = setTimeout(() => {
				setIsOpen(false);
			}, 2000);
		}
		return () => {
			clearTimeout(timeoutId);
		};
	}, [isOpen]);

	return (
		<>
			<span onClick={() => { navigator.clipboard.writeText(orderId); setIsOpen(true); }} ref={setButtonRef} style={{ cursor: 'pointer', display: 'inline' }}>
				{orderId} <ContentCopyIcon size="medium" title="Copy order ID" />
			</span>
			<Popover
				className='small-pop'
				anchorElement={buttonRef}
				isOpen={isOpen}
				label="Copied to clipboard"
				placement="top"
				onClose={() => setIsOpen(false)}>
				<Text><strong>{orderId}</strong> copied to clipboard</Text>
			</Popover>
		</>
	);
}

export default {
	NewTabButton,
	ViewOrderButton,
	CopyOrderNumberButton,
};

